var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4"},[(_vm.isDataLoaded)?_c('apexchart',{staticClass:"mx-auto",attrs:{"width":"100%","height":"450","options":_vm.getChartOptions,"series":_vm.getChartSeries}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }